import { render, staticRenderFns } from "./taxationAi.vue?vue&type=template&id=6cdd8d02&scoped=true&"
import script from "./taxationAi.vue?vue&type=script&lang=js&"
export * from "./taxationAi.vue?vue&type=script&lang=js&"
import style0 from "./taxationAi.vue?vue&type=style&index=0&id=6cdd8d02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdd8d02",
  null
  
)

export default component.exports